import React, { useEffect, useState } from "react";
import { getPublicRealities } from "../api/doarPlatformApi";
import RealityCard from "../components/reality/RealityCard";
import RealityHeader from "../components/reality/RealityHeader";
import RealityToDoARCollapse from "../components/reality/RealityToDoARCollapse";
import "./Reality.css";

export default function MarketplaceHome() {
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [realities, setRealities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    document.documentElement.dataset.doarSurface = "reality";
    return () => { delete document.documentElement.dataset.doarSurface; };
  }, []);

  useEffect(() => {
    let live = true;
    setLoading(true);
    setError("");
    getPublicRealities({ marketplace: true, search: query || undefined, limit: 36 })
      .then(data => { if (live) setRealities(data?.realities || []); })
      .catch(() => { if (live) { setRealities([]); setError("Marketplace Realities could not be loaded."); } })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [query]);

  const submit = event => { event.preventDefault(); setQuery(search.trim()); };

  return (
    <RealityToDoARCollapse>
    <main className="reality-marketplace">
      <RealityHeader />

      <section className="marketplace-hero">
        <p className="reality-kicker">Marketplace</p>
        <h1>Realities to buy,<br/>license or commission.</h1>
        <p>Marketplace is the commercial layer for Design Objects. Open any Reality to experience it first, then obtain what is actually offered.</p>
        <form className="reality-search" onSubmit={submit} role="search">
          <input value={search} onChange={event => setSearch(event.target.value)} placeholder="Search Marketplace Realities…" aria-label="Search Marketplace" />
          <button type="submit">Search</button>
        </form>
      </section>

      <div className="marketplace-note">Every Marketplace item is an authorised Reality of an underlying DoAR. Commerce never replaces the Design Object.</div>

      <section className="reality-section" aria-live="polite">
        <div className="reality-section__head"><div><p className="reality-kicker">Available</p><h2>{query ? `Results for “${query}”` : "Marketplace Realities"}</h2></div></div>
        {loading ? <div className="reality-grid">{[1,2,3,4,5,6,7,8].map(key => <i className="reality-skeleton" key={key}/>)}</div> : error ? (
          <div className="reality-empty"><h3>Marketplace unavailable.</h3><p>{error}</p></div>
        ) : realities.length ? (
          <div className="reality-grid">{realities.map(item => <RealityCard key={item.id} reality={item} />)}</div>
        ) : (
          <div className="reality-empty"><h3>No commercial Realities match yet.</h3><p>Explore all public Realities or create your own Design Object.</p><a href="/">Explore Realities →</a></div>
        )}
      </section>

      <footer className="reality-footer"><span>© DoAR · Marketplace for available Realities</span><div><a href="/">Explore</a><a href="/terms">Terms</a><a href="/privacy">Privacy</a></div></footer>
    </main>
    </RealityToDoARCollapse>
  );
}
